import { createSelectField } from 'components/fields/createSelectField';
import type { Category } from './types';

export const CategoryField = createSelectField<Category>('supplier/categories/', {
  getOptionLabel: ({ name }: Category) => name,
  getOptionValue: (a: Category) => a.id.toString(),
});
